import React from "react";
import dialogPolyfill from "dialog-polyfill";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";
import { classes } from "typestyle";
import { paths } from "../../App";
import { cancelCheckout } from "../../dao/reservation";
import { Button } from "@hooplab/ui-components";
import Heading from "../Heading";
import * as styles from "./styles";
import "dialog-polyfill/dist/dialog-polyfill.css";

interface IProps {
  close: () => void;
  eventId: string;
  canComplete: boolean;
  open: boolean;
}

const CheckoutLockedReservationModal: React.FC<IProps> = ({
  close,
  canComplete,
  open,
  eventId,
}) => {
  const dialogRef = React.useRef<HTMLDialogElement>(null);

  const navigate = useNavigate();

  React.useEffect(() => {
    if (open && dialogRef.current) {
      dialogPolyfill.registerDialog(dialogRef.current);
      dialogRef.current.showModal();
    } else if (!open && dialogRef?.current) {
      dialogPolyfill.registerDialog(dialogRef.current);
      dialogRef.current.close();
    }
  }, [open]);

  return (
    <dialog ref={dialogRef} className={styles.dialogStyle}>
      <div className={classes(styles.infoBox)}>
        <div className={styles.heading}>
          <Heading size="xl2">
            <FormattedMessage
              id={"screens.Event.checkoutLock"}
              defaultMessage={"Ongoing checkout"}
            />
          </Heading>
        </div>
        <div className={styles.infoBoxContent}>
          <div>
            {canComplete ? (
              <FormattedMessage
                id={"screens.Event.checkoutLockInfoCanComplete"}
                defaultMessage={
                  "An ongoing checkout exists for this reservation. To proceed, either complete the ongoing checkout, or cancel it to update your reservation."
                }
              />
            ) : (
              <FormattedMessage
                id={"screens.Event.checkoutLockInfoCannotcomplete"}
                defaultMessage={
                  "An ongoing checkout exists for this reservation. To proceed, cancel the checkout to update your reservation."
                }
              />
            )}
          </div>
        </div>
        <div className={styles.footerActions}>
          <Button
            theme="RED"
            className={styles.footerButton}
            onClick={() => {
              cancelCheckout(eventId).then((res) => {
                close();
              });
            }}
          >
            <FormattedMessage
              id={"screens.Event.cancelCheckout"}
              defaultMessage={"Cancel checkout"}
            />
          </Button>
          {canComplete && (
            <Button
              theme="GREEN"
              className={styles.footerButton}
              onClick={() => navigate(paths.checkout(eventId))}
            >
              <FormattedMessage
                id={"screens.Event.completeCheckout"}
                defaultMessage={"Complete checkout"}
              />
            </Button>
          )}
        </div>
      </div>
    </dialog>
  );
};

export default CheckoutLockedReservationModal;
